"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.hero.title': '账户激活',
    'activate.hero.description': '欢迎使用IntHub！我们正在激活您的账户以便您开始使用。',
    'activate.hero.login_link_text': '已经有活跃账户？',
    'activate.hero.login_link': '在此登录',
};
